import { BasePropertySearchComponent } from './base-property-search.component';
import { PropertySearchComponent } from './property-search/property-search.component';
import { MarketSearchComponent } from './market-search/market-search.component';
import { SubmarketSearchComponent } from './submarket-search/submarket-search.component';
import { GooglePropertySearchComponent } from './google-property-search/google-property-search.component';

const SEARCH_COMPONENTS = [
  BasePropertySearchComponent,
  GooglePropertySearchComponent,
  PropertySearchComponent,
  MarketSearchComponent,
  SubmarketSearchComponent
];

export {
  BasePropertySearchComponent,
  GooglePropertySearchComponent,
  PropertySearchComponent,
  MarketSearchComponent,
  SubmarketSearchComponent,
  SEARCH_COMPONENTS
}



// WEBPACK FOOTER //
// ./src/app/shared/components/search/index.ts